module.exports = __webpack_public_path__ + "static/blog-post-1.3-58d189691232625389378a3d9f0801ff.png";